<template>
  <div
    class="toggle"
    @click="toggle"
  >
    <h3>{{ $config.common.search.title }}</h3>
    <form>
      <span
        class="toggle-value"
        :class="{ 'active': !isChecked}"
      >
        {{ $config.common.search.by_value.label }}
      </span>
      <div
        :class="['toggle-button', { 'toggle-button--checked': isChecked }]"
      >
        <div class="toggle-button__switch" />
      </div>
      <span
        class="toggle-value"
        :class="{ 'active': isChecked}"
      >
        {{ $config.common.search.by_collection.label }}
      </span>
    </form>
  </div>
</template>

<script>
export default {
  name: 'FilterTypeToggleButton',
  data() {
    return {
    };
  },
  computed: {
    isChecked() {
      return this.$store.state.filters.filterType === 'collection';
    },
  },
  methods: {
    toggle() {
      this.$store.commit('setFilterType', this.isChecked ? 'value' : 'collection');
    },
  },
};
</script>

<style lang="stylus" scoped>
.toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 24px;
  line-height: 100%;
  font-weight: bold;
  color: $cl-dark-blue;
  cursor: pointer;
  width: 100%;

  +mobile() {
    font-size: 20px;
    gap: 10px;
    justify-content: space-around; // remove to keep center alignment
  }

  h3 {
    text-transform: none;
    font-weight: 500;
    margin: 0;
    padding: 1px 0 0 0;
    // flex-shrink: 0;
    +mobile() {
      padding: 2px 0 0 0
    }
  }
  form {
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: center;
    padding-top: 1px; // offset for better visual alignment with switch
    +mobile() {
      gap: 6px;
    }
  }
  span {
    display: block;
    margin: 0;
    flex-shrink: 1;
    padding-top: 1px;
    +mobile() {
      font-size: 18px;
      padding-top: 2px
    }
  }
  .toggle-button {
    width: 54px;
    height: 30px;
    background-color: $cl-dark-blue;
    border-radius: 25px;
    position: relative;
    cursor: pointer;
    transition: background-color 0.3s;
    flex-shrink: 0;
    margin-top: -2px;
  }

  .toggle-button--checked {

  }

  .toggle-value {
    opacity: 0.5;
    transition: opacity 0.3s;
    &.active {
      opacity: 1;

    }
  }

  .toggle-button__switch {
    width: 24px;
    height: 24px;
    background-color: $cl-yellow;
    border-radius: 50%;
    position: absolute;
    top: 3px;
    left: 3px;
    transition: left 0.3s;
  }

  .toggle-button--checked .toggle-button__switch {
    left: 27px;
  }
}
</style>
